import { useIntl } from '@/intl'
import { useState } from 'react'

export const useTexts = () => {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    save: (count: number) => translate({ id: 'orders.edit.bulk.save', values: { count } }),
    cancel: translate({ id: 'global.cancel' }),
    bulkOrderHeaderTitle: (orderCount: number) =>
      translate({ id: 'orders.edit.bulk.header.title', values: { orderCount } }),

    getContactInformationTitle: translate({ id: 'orders.form.bulk.contactInformation.title' }),

    getAdditionalInformationTitle: translate({
      id: 'orders.form.bulk.additionalInformation.title',
    }),
    getServiceTimeAndAvailabilitiesTitle: translate({
      id: 'orders.form.bulk.serviceTimeAndAvailabilities.title',
    }),
    getEligibilityAndReccurenceTitle: translate({
      id: 'orders.form.bulk.eligibilityAndReccurence.title',
    }),

    tagsIn: translate({ id: 'orders.edit.field.tags.in' }),
    tagsOut: translate({ id: 'orders.edit.field.tags.out' }),
    overlappingTags: translate({ id: 'order.form.bulk.errors.tag.overlapping' }),

    loads: translate({ id: 'orders.edit.field.loads' }),
  }))

  return api
}
